export default __webpack_public_path__ + "static/item_14-e87d39308e6c8e641a80133be44f3333.jpg";